import { formatDisplayShort } from '../../../lib/dateUtils';
import Card from '../../../components/ui/Card';
import Button from '../../../components/ui/Button';
import Badge from '../../../components/ui/Badge';

/**
 * Outstanding repairs tab panel for the site details page.
 * All data and handlers come from the parent via props.
 */
export default function SiteDetailsRepairsPanel({
  repairCount,
  repairs,
  repairsLoading,
  onRepairSession,
}) {
  return (
    <Card>
      {repairCount > 0 && (
        <>
          <div className="import-hint" style={{ backgroundColor: 'var(--warning-bg)', color: 'var(--warning)', padding: '0.75rem 1rem', borderRadius: 6, marginBottom: '1rem', border: '1px solid var(--warning-border)' }}>
            <strong>Action required.</strong> There are {repairCount} asset{repairCount !== 1 ? 's' : ''} marked as failed requiring repair.
          </div>
          <Button
            type="button"
            variant="primary"
            onClick={onRepairSession}
            style={{ minHeight: '48px', marginBottom: '1rem' }}
          >
            Start Repair Session
          </Button>
        </>
      )}
      {repairsLoading ? (
        <p className="text-muted">Loading repairs…</p>
      ) : repairCount === 0 ? (
        <p className="text-muted">No outstanding repairs for this site.</p>
      ) : (
        <div className="table-container">
          <table className="data-table">
            <thead>
              <tr>
                <th>Asset & type</th>
                <th>Location</th>
                <th>Failed date</th>
                <th>Original issue</th>
                <th>Status</th>
              </tr>
            </thead>
            <tbody>
              {repairs.map((r) => (
                <tr key={r.asset_id}>
                  <td>
                    <strong>{r.asset_name || r.equipment_code || r.asset_code || `Asset ${r.asset_id}`}</strong>
                    <div className="text-muted text-xs">{(r.asset_type || '').replace(/_/g, ' ')}</div>
                  </td>
                  <td>{(r.building || '').trim() || '—'} / {(r.room || '').trim() || '—'}</td>
                  <td>{r.failed_at ? formatDisplayShort(r.failed_at) : '—'}</td>
                  <td>{r.defects_found || '—'}</td>
                  <td><Badge variant="warning">Outstanding</Badge></td>
                </tr>
              ))}
            </tbody>
          </table>
        </div>
      )}
    </Card>
  );
}
